// @flow
import { handleActions, type ActionType } from 'redux-actions';
import { requestContent, receiveContent } from './secondOpinionActions';

export type State = {
  +contentRequestStatus: RequestStatus,
  +ugcId: ?string,
};

export type SecondOpinionState = State;

const defaultState: State = {
  contentRequestStatus: 'pending',
  ugcId: null,
};

export default handleActions(
  {
    [requestContent.toString()]: (
      state: State,
      action: ActionType<typeof requestContent>
    ) => ({
      ...state,
      contentRequestStatus: 'pending',
    }),

    [receiveContent.toString()]: {
      next(state: State, action: ActionType<typeof receiveContent>) {
        return {
          ...state,
          ugcId: action.payload.ugc_id,
          contentRequestStatus: 'complete',
        };
      },
      throw(state: State, action: ActionType<typeof receiveContent>) {
        return {
          ...state,
          contentRequestStatus: action.payload,
        };
      },
    },
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/pages/moderation/second-opinion/secondOpinionReducer.js